import React from "react";
import Footer from "../Footer/Footer.jsx";
import "./Home.css";

const Home = () => {
  return (
    <>
      <div className="home-body">
        <div className="header">
          <Footer />
        </div>
        <div className="main-content">
          <h1>PRODUCING TALENTS</h1>
          <div className="center">
          <p className="gagaland">
            A gagaland where talents are born and made
          </p>
          </div>
          <div
            style={{ position: "relative", display: "flex", width: "100%", height: "50%" }}
            className="tag-lines"
          >
            <div
              className="tag-line"
            >
              Passion. Persistence. Podium.
            </div>
            <div
              className="tag-line grandstand"
            >
              The Grandstand for Talents
            </div>
          </div>
          <div className="center">
          <button
            className="button-style"
          >
          <a style={{textDecoration:"none", color:"black"}} target="_blank" href="https://0v7luj5oxcg.typeform.com/to/Ye7nWUfc">
            {"Register for the beta version"}
            </a>
          </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
